import { render, staticRenderFns } from "./SourceTable.vue?vue&type=template&id=dedd339c&scoped=true"
import script from "./SourceTable.vue?vue&type=script&lang=js"
export * from "./SourceTable.vue?vue&type=script&lang=js"
import style0 from "./SourceTable.vue?vue&type=style&index=0&id=dedd339c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedd339c",
  null
  
)

export default component.exports